import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_LV.json';
import exercises from './YOGA_EXERCISES_LV.json';
import recipes from './YOGA_RECIPES_LV.json';

export const YOGA_DATA_LV: ServiceData = {
  articles,
  exercises,
  recipes,
};
